import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase'; 
// YENİ: Loglama aracı
import { logIslem } from '../utils/logger';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState(''); 
  const [password, setPassword] = useState('');
  const [error, setError] = useState(''); 
  const [loading, setLoading] = useState(false); 

  const handleLogin = async (e) => {
    e.preventDefault(); 
    setError(''); 
    setLoading(true); 

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      // Giriş Logu Tutalım
      logIslem("Giriş", `${user.email} sisteme giriş yaptı.`, user.email);

      // Yönlendirme Mantığı
      if (user.email === 'admin@arasasaf.com') {
        navigate('/admin/dashboard');
      } 
      else if (user.email === 'patron@arasasaf.com') {
        navigate('/patron/dashboard');
      }
      // --- YENİ: TEKNİK HESAP ---
      else if (user.email === 'teknik@zeze.com') {
        navigate('/teknik/logs'); // Direkt log sayfasına gitsin
      }
      else {
        setError('Bu kullanıcı rolü tanımlanmamış.');
        auth.signOut();
        navigate('/');
      }

    } catch (error) {
      console.error("Giriş hatası:", error);
      setError('E-posta veya şifre hatalı!');
    } finally {
      setLoading(false); 
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2 className="brand-logo" style={{justifyContent: 'center', color: '#1a1a1a', fontSize: '1.8rem', marginBottom: '30px'}}>
            <img src="/logo.png" alt="Logo" style={{height: '50px'}} />
            Sistem Girişi
        </h2>
        
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <label>E-posta Adresi</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="mail@adres.com" />
          </div>
          <div className="input-group">
            <label>Şifre</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="******" />
          </div>

          {error && <p className="login-error">{error}</p>}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>
        
        <Link to="/" className="back-link">← Ana Sayfaya Dön</Link>
      </div>
    </div>
  );
}

export default Login;